/**
 * 关于用户的一些接口
 */

import result from '@/utils/result'

export async function getWechatWork() {
  return result('api/workwx/cfg', 'get')
}
export async function getBanner() {
  return result('api/guestuser/banner', 'get')
}

// 提交订单
export async function savePerson(data) {
  return result('api/guestuser/visitorder', 'post', data)
}
// 提交订单
export async function getGuestOrder(data) {
  return result('api/guestuser/guestorder', 'get', data)
} 

// 提交订单
export async function getGuestOrderDetail(data) {
  return result('api/guestuser/guestorderdetail', 'get', data)
}
// 获取校区
export async function getCampus(data) {
  return result('api/guestuser/campus', 'get', data)
}
// 获取设置
export async function getCfg(data) {
  return result('api/guestuser/syscfg', 'get', data)
}

